import { useState, useEffect } from 'react';
import { findNearestLocations } from '../../context/location/MapActions';
import PlacesAutoComplete from '../map/PlacesAutoComplete';
import { FaLocationPin } from 'react-icons/fa6';
import { getFacilitiesSummary } from '../../context/facility/FacilityActions';

const DistanceInfo= ( userLocation ) => {
    const [selected, setSelected] = useState(null);
    const [showAllFacilities, setShowAllFacilities] = useState(false);
    const [nearestLocations, setNearestLocations] = useState([]);
    const [facilitiesSummary, setFacilitiesSummary] = useState(null);
    //if selected location is set, use it else if current location is set use it
    const numberOfFacilities = process.env.REACT_APP_NUMBER_OF_TOP_FACILITIES;

    const toggleShowFacilities = () => {
        setShowAllFacilities(!showAllFacilities);
      };

    useEffect(() => {
        let isMounted = true;   
        (async () => {
            const [rFacilitiesSummary] = await Promise.all([
                getFacilitiesSummary(),
            ]);
            if (!isMounted) return;
            if (!rFacilitiesSummary.error) setFacilitiesSummary(rFacilitiesSummary.data);

        })();
    return () => { isMounted = false; };
    }, []);
    


    useEffect(() => {
        if(selected){
            setNearestLocations(findNearestLocations(selected, numberOfFacilities, facilitiesSummary))
        }else if(userLocation.userLocation){
            if (process.env.REACT_APP_NODE_ENV !== 'production') console.log(userLocation)
            const { latitude, longitude } = userLocation.userLocation;
            const coordinates = { lat: latitude, lng: longitude};
            if (process.env.REACT_APP_NODE_ENV !== 'production') console.log(coordinates)
            setNearestLocations(findNearestLocations(coordinates, numberOfFacilities, facilitiesSummary))
    
        }
    if (process.env.REACT_APP_NODE_ENV !== 'production') console.log(nearestLocations);
    },[selected, userLocation]);
    
    return (
        <>
            <div className='w-full flex flex-col justify-center items-center h-auto text-white font-bold text-xl sm:text-5xl bg-teal-900'>
                <div>LOCATE OUR OFFICES</div>
                <div className='sm:text-xl p-2 justify-center text-center'>Enter a location and search to see a list of our offices closest to your location</div>
            </div>


            <div className="w-full flex justify-center p-8 text-gray font-bold text-xl sm:text-3xl">
                <div className="text-center md:mr-2 mb-4 md:mb-0 md:leading-relaxed w-full">
                    <div className="places-container">
                        <PlacesAutoComplete setSelected={setSelected} />
                    </div>

                    <div className='sm:text-2xl mb-8'>
                        {userLocation?.userLocation?.localityInfo && (
                            <div>
                                Current Location: {userLocation.userLocation.localityInfo.administrative[4]?.name || userLocation.userLocation.localityInfo.administrative[3]?.name || 'Location not available'}
                            </div>
                        )}
                    </div>


                    {nearestLocations.map((location, index) => (
                        <div key={index} className={`grid grid-cols-3 col-span-4 p-4 sm:text-sm md:text-2xl font-light ${index % 2 === 0 ? 'bg-slate-200' : ''}`}>
                            <div className='grid grid-cols-1'>
                                    {location.name}
                                </div>
                                <div>
                                    {location.address}
                                </div>
                                <div>
                                    {location.distance.toFixed(2)}Km
                                </div> 
                        </div>
                    ))}


                    <div className='w-full flex md:flex-row justify-center items-center h-auto p-8 text-gray font-bold text-xl sm:text-5xl'>
                        <div className='fetext-center md:mr-2 mb-4 md:mb-0 md:leading-relaxed w-full'>
                            <div onClick={toggleShowFacilities} className='btn btn-primary btn-ghost btn-lg bg-gray-700 text-white border-none'>
                                <FaLocationPin className='mr-2' />
                                {showAllFacilities ? 'Hide All Locations' : 'View All Locations'}
                            </div>

                        </div>
                    </div>
                    
                    {showAllFacilities && (
                        <div className='w-full flex md:flex-col flex-row justify-center items-center h-auto p-8 text-gray font-bold text-xl sm:text-5xl'>
                            <div className='fetext-center md:mr-2 mb-4 md:mb-0 md:leading-relaxed w-full'>
                                    {facilitiesSummary && facilitiesSummary.map((location, index) => (
                                        <div key={index} className={`grid grid-cols-3 col-span-4 p-4 sm:text-sm md:text-2xl font-light ${index % 2 === 0 ? 'bg-slate-400' : ''}`}>
                                            <div>
                                                {location.name}
                                            </div>
                                            <div>
                                                {location.state}
                                            </div> 
                                            <div>
                                                {location.address}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>

        </>
    );
}

export default DistanceInfo;